import React from 'react';
import { Modal, Box, Typography, Button } from '@mui/material';
import './delete-dialog-box.css';
import crossIcon from '../../assets/images/authimgs/cross-circle.png'

const DeleteDialogBox = ({ isDeleteOpen, onDeleteClose, onConfirm, title, description }) => {
    return (
        <Modal open={isDeleteOpen} onClose={onDeleteClose}>
            <Box className="confirm-deletion-modal"
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 1,
                }}
            >
                <div className='modal-header-img-col'>
                    <img src={crossIcon} alt='cross-icon'/>
                </div>

                <Typography variant="h5" component="h3" gutterBottom className='modal-heading'>
                    {title}
                </Typography>
                <Typography variant="body1" gutterBottom className='modal-body-text'>
                    {description}
                </Typography>
                <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }} className='modal-actionBtn'>
                    <Button onClick={onDeleteClose} sx={{ marginRight: 1 }} className='btn cancel-btn'>
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} variant="contained"  color="error" className='btn confirm-btn'>
                        Confirm
                    </Button>
                </Box>
            </Box>
        </Modal>
    );
};

export default DeleteDialogBox;
